import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
import { SubjectsService } from 'src/services/subjects.service';
import { UserService } from 'src/services/user.service';

@Component({
   selector: 'app-foster-family-member',
   templateUrl: './foster-family-member.component.html',
   styleUrls: ['./foster-family-member.component.scss'],
})
export class FosterFamilyMemberComponent implements OnInit {
   @Input() firstName = '';
   @Input() lastName = '';
   @Input() regId: number;
   @Input() isFosterParent: boolean;
   @Input() cpsuSubjectId: any;

   fullName: string;
   status: string;
   subjectDetailsLink: string;
   isAdmin: boolean;

   object: any = {
      document: '',
      action: '',
      subjectId: '',
      message: '',
      title: '',
   };
   constructor(private translate: TranslateService, private subjectsService: SubjectsService, public dialog: MatDialog, private userService: UserService) {
      this.isAdmin = this.userService.isGlobalAdmin();
   }

   ngOnInit(): void {
      this.fullName = `${this.firstName} ${this.lastName}`;
   }

   openDetailsNewTab() {
      window.open(environment.getCpsuSubjectDetails + this.cpsuSubjectId, '_blank');
   }
}
